export const getStatusColor = (value: number | null | undefined, defaultColor: string): string => {
    if (!value && value !== 0) return defaultColor;
    if (value > 100) return "#15803D";
    if (value === 100) return "#22C55E";
    if (value >= 80) return "#EAB308";
    if (value >= 50) return "#F97316";
    if (value >= 20) return "#F43F5E";
    return "#BE123C";
};

export const getProgressColor = (value: number | null | undefined, defaultColor: string): string => {
    if (!value && value !== 0) return defaultColor;
    if (value > 100) return "#15803D";
    if (value === 100) return "#22C55E";
    if (value >= 80) return "#FACC15";
    if (value >= 50) return "#FB923C";
    if (value >= 20) return "#F43F5E";
    return "#BE123C";
};
